export default "__VITE_ASSET__BXZSeEYH__"